<template>
  <div class="prices">
    <el-table
      :data="filteredPrices"
      style="width: 100%">
      <el-table-column
        label="-"
        width="50">
        <template slot-scope="scope">
          <pricing-controls
            :price="scope.row"
            @removed="bindPrices.splice(bindPrices.indexOf($event), 1)"
            leftControl />
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="Gas"
        width="200">
          <template slot-scope="scope">
            <div class="sub-prop">
              {{ scope.row.gasType.name }}
              <span v-if="scope.row.name !== null">{{ scope.row.name }}</span>
            </div>
          </template>
      </el-table-column>
      <el-table-column
        prop="price"
        label="Price/L">
      </el-table-column>
      <el-table-column
        prop="station.name"
        label="Station"
        :formatter="stationFormatter">
      </el-table-column>
      <el-table-column
        v-if="$screen.desktop"
        prop="group.name"
        label="Group"
        :formatter="groupFormatter">
      </el-table-column>
      <el-table-column
        prop="user.name"
        label="Member"
        :formatter="memberFormatter">
      </el-table-column>
      <el-table-column
        fixed="right"
        width="120">
        <template slot-scope="scope">
          <pricing-controls :price="scope.row" :organization="organization" @updated="updatePrice(scope.row, $event)" />
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import PricingControls from './Pricing/PricingControls'

export default {
  name: 'Prices',
  components: { PricingControls },
  props: {
    organization: {
      type: Object,
      required: true
    },
    search: {
      type: String,
      required: true
    },
    prices: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      bindPrices: this.prices,
      extrasObj: this.extras || []
    }
  },
  watch: {
    prices () {
      this.bindPrices = this.prices
    }
  },
  computed: {
    filteredPrices () {
      return this.bindPrices.filter(item => {
        if (item.name === null) {
          if (item.gasType.name.toLowerCase().indexOf(this.search.toLowerCase()) !== -1) {
            return item
          }
        } else {
          if (item['name'].toLowerCase().indexOf(this.search.toLowerCase()) !== -1) {
            return item
          }
        }
      })
    }
  },
  methods: {
    updatePrice (price, updatedPrice) {
      const index = this.bindPrices.indexOf(price)
      this.bindPrices[index].name = updatedPrice.name
      this.bindPrices[index].price = updatedPrice.price
      this.bindPrices[index].gasType = updatedPrice.gasType
      this.bindPrices[index].user = updatedPrice.user
      this.bindPrices[index].station = updatedPrice.station
      this.bindPrices[index].group = updatedPrice.group
    },
    priceNameFormat (row) {
      return (row.name !== null ? row.name + ' - ' : '') + row.gasType.name
    },
    stationFormatter (row) {
      if (row.station === null) {
        return '-'
      }

      return row.station.name
    },
    memberFormatter (row) {
      if (row.user === null) {
        return '-'
      }

      return row.user.name
    },
    groupFormatter (row) {
      if (!row.group) {
        return '-'
      }

      return row.group.name
    },
    async removePrice (price) {
      const response = await this.$http.delete(this.$api.organization(this.$route.params.orgId).gasPrice(price.id).remove)
      this.$message.success('Price removed successfully')
      this.bindPrices.splice(this.bindPrices.indexOf(price), 1)
    }
  }
}
</script>

<style lang="scss" scoped>
  
</style>



// WEBPACK FOOTER //
// src/components/dashboard/organizations/organization/lists/Pricing.vue